import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';

@Injectable({ providedIn: 'root' })
export class ProcessesViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);


  canActivate(): Promise<boolean> {
    return this.routeGuardService.handleRoute(this.getView());
  }
  getView(): View {
    return {
      route: 'workflows2',
      iframeUrl: 'workflows2',
    };
  }
}
